import { action } from "typesafe-actions";
import { StreamingActionTypes } from "./streaming.model";

export const fetchAppTokenRequest = (req) =>
    action(StreamingActionTypes.GET_APP_TOKEN_REQUEST, req);
export const fetchAppTokenSuccess = (res) =>
    action(StreamingActionTypes.GET_APP_TOKEN_SUCCESS, res);
export const fetchAppTokenFailure = (err) =>
    action(StreamingActionTypes.GET_APP_TOKEN_FAILURE, err);

export const createRoomRequest = (req) =>
    action(StreamingActionTypes.CREATE_ROOM_REQUEST, req);
export const createRoomSuccess = (res) =>
    action(StreamingActionTypes.CREATE_ROOM_SUCCESS, res);
export const createRoomFailure = (err) =>
    action(StreamingActionTypes.CREATE_ROOM_FAILURE, err);

export const fetchSessionRequest = (req) =>
    action(StreamingActionTypes.GET_SESSIONS_REQUEST, req);
export const fetchSessionSuccess = (res) =>
    action(StreamingActionTypes.GET_SESSIONS_SUCCESS, res);
export const fetchSessionFailure = (err) =>
    action(StreamingActionTypes.GET_SESSIONS_FAILURE, err);
